import GroupIcon from '@mui/icons-material/Group';

export function GerenciamentoIcon() {
  return <GroupIcon />;
}
